const colors = {
    primaryColor: '#F1A960',
    secondColor: '#5D074E',
    background: '#1A237E',
    textColor: '#FFFF',
    darkColor: '#455A64',
    darkBackground: '#33383b',
    lightBackground: '#f8f9fa'
  }
  
  export default colors